var e;!function(e){e.reply="reply",e.original="original",e.search="search",e.pinnedSearch="pinnedSearch",e.quote="quote"}(e||(e={}));export{e as CardType};
